// extracted by mini-css-extract-plugin
export default {"root_menu":"RootMenu_root_menu__fPR4g","root_menu__inner":"RootMenu_root_menu__inner__NCZ0o","spin":"RootMenu_spin__x0T0i"};